import { getWindow } from '@surfline/web-common';

export const STORAGE_KEY = 'sl_lineup_cam_overlay';
export const OVERLAY_FREQUENCY = 5;
export const MAX_OVERLAYS_PER_CAM = 10;

interface OverlayStats {
  visits: number;
  shown: number;
}

type OverlayData = Record<string, OverlayStats>;

const DEFAULT_STATS: OverlayStats = { visits: 0, shown: 0 };

const readStorage = (): OverlayData => {
  try {
    const raw = getWindow()?.localStorage?.getItem(STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw) as OverlayData;
  } catch {
    return {};
  }
};

const writeStorage = (data: OverlayData): void => {
  try {
    getWindow()?.localStorage?.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // localStorage unavailable — silently skip
  }
};

export const getOverlayStats = (cameraId: string): OverlayStats => {
  const data = readStorage();
  return data[cameraId] ?? { ...DEFAULT_STATS };
};

export const incrementVisits = (cameraId: string): OverlayStats => {
  const data = readStorage();
  const stats = data[cameraId] ?? { ...DEFAULT_STATS };
  stats.visits += 1;
  data[cameraId] = stats;
  writeStorage(data);
  return stats;
};

export const incrementShown = (cameraId: string): void => {
  const data = readStorage();
  const stats = data[cameraId] ?? { ...DEFAULT_STATS };
  stats.shown += 1;
  data[cameraId] = stats;
  writeStorage(data);
};

export const shouldShowOverlay = (visits: number, shown: number): boolean =>
  shown < MAX_OVERLAYS_PER_CAM && visits % OVERLAY_FREQUENCY === 1;
